import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/views/layout/index'
//import userCenter from '@/views/userCenter/components/layout'

Vue.use(Router)
const companyCenterRouter =[
    {
        path:'/companyCenter-before',
        component:()=>import('@/views/companyCenter/companyCenter-before'),//企业中心-专项自查 前
        name:'companyCenter-before',
        linkActiveClass:'active',
        meta:{
            requireAuth:true
        }
    },
    {
        path:'/companyCenter-after',
        component:()=>import('@/views/companyCenter/companyCenter-after'),//企业中心-专项自查 后
        name:'companyCenter-after',
        linkActiveClass:'active',
        meta:{
            requireAuth:true
        }
    },
  {
    path: '/',
    component: Layout,
    name:"companyCenter",
    children: [
    
    {
        path: '/companyCenter-info',
        component: () => import('@/views/companyCenter/companyCenter-info-f'),//企业中心-单位基本信息
        name: 'companyCenter-info',
        linkActiveClass:'active',
        meta:{
            requireAuth:true
        }
    },
    {
        path:'/companyCenter-userManage',
        component:()=>import('@/views/companyCenter/companyCenter-userManage'),//企业中心-软件用户管理-健康顾问
        name:'companyCenter-userManage',
        meta:{
            requireAuth:true
        },
        children:[
            {
                path:'/companyCenter-userManage/3',
                component:()=>import('@/views/companyCenter/companyCenter-userManage-jkgw'),//企业中心-软件用户管理-健康顾问
                name:'companyCenter-userManage-jkgw',
                linkActiveClass:'active',
                meta:{
                    requireAuth:true
                }
            },
            {
                path:'/companyCenter-userManage/4',
                component:()=>import('@/views/companyCenter/companyCenter-userManage-zyjkjt'),//企业中心-软件用户管理-职业健康集团
                name:'companyCenter-userManage-zyjkjt',
                linkActiveClass:'active',
                meta:{
                    requireAuth:true
                }
            },
            {
                path:'/companyCenter-userManage/1',
                component:()=>import('@/views/companyCenter/companyCenter-userManage-zyjkqy'),//企业中心-软件用户管理-职业健康企业
                name:'companyCenter-userManage-zyjkqy',
                linkActiveClass:'active',
                meta:{
                    requireAuth:true
                }
            },
            {
                path:'/companyCenter-userManage/2',
                component:()=>import('@/views/companyCenter/companyCenter-userManage-ffs'),//企业中心-软件用户管理-放辐射
                name:'companyCenter-userManage-ffs',
                linkActiveClass:'active',
                meta:{
                    requireAuth:true
                }
            },
        ]
    },
    {
    	path:'/companyCenter-orderSoftpay',
    	component:()=>import('@/views/companyCenter/companyCenter-orderSoftpay'),//企业中心-订单管理续费
        name:'companyCenter-orderSoftpay',
        linkActiveClass:'active',
        meta:{
            requireAuth:true
        }
    },
    {
    	path:'/companyCenter-orderManage',
    	component:()=>import('@/views/companyCenter/companyCenter-orderManage'),//企业中心-订单管理
        name:'companyCenter-orderManage',
        linkActiveClass:'active',
        meta:{
            requireAuth:true
        }
    },
    {
        path:'/companyCenter-orderManageDetail/:id',
        component:()=>import('@/views/companyCenter/companyCenter-orderManageDetail'),//企业中心-订单管理详情
        name:'companyCenter-orderManageDetail',
        linkActiveClass:'active',
        meta:{
            requireAuth:true
        }
    },
    {
        path: '/companyCenter-changeEmail',
        component: () => import('@/views/companyCenter/companyCenter-changeEmail'),//企业中心-邮箱换绑
        name: 'companyCenter-changeEmail',
        linkActiveClass:'active',
        meta:{
            requireAuth:true
        }
    },
    {
    	path:'/companyCenter-changePwd',
    	component:()=>import('@/views/companyCenter/companyCenter-changePwd'),//企业中心-密码修改
        name:'companyCenter-changePwd',
        linkActiveClass:'active',
        meta:{
            requireAuth:true
        }
    },
    {
    	path:'/companyCenter-message',
    	component:()=>import('@/views/companyCenter/companyCenter-message'),//企业中心-意见和建议
        name:'companyCenter-message',
        linkActiveClass:'active',
     	meta:{
       	requireAuth:true
       }
    },
    {
    	path:'/companyCenter-notice',
    	component:()=>import('@/views/companyCenter/companyCenter-notice'),//企业中心-系统消息
        name:'companyCenter-notice',
        linkActiveClass:'active',
     	meta:{
       	requireAuth:true
       }
    }
    ]
	}
]
export default companyCenterRouter



// WEBPACK FOOTER //
// ./src/router/companyCenter.js